export default {

  setup() {

    console.log('Forms are set up');

    let passwordFields = document.querySelectorAll(".password-field");

    passwordFields.forEach((element) => {
      let input = element.querySelector('input');
      let button = element.querySelector('button');

      button.addEventListener("click", togglePassword);

      function togglePassword() {
        if (input.type === 'password') {
          input.type = 'text';
          button.textContent = 'Hide';
          button.setAttribute('aria-label',
            'Hide password.');
        } else {
          input.type = 'password';
          button.textContent = 'Show';
          button.setAttribute('aria-label',
            'Show password as plain text. ' +
            'Warning: this will display your password on the screen.');
        }
      }
    });

  },
  destroy() {

  },
}